import { Cell, Heading, Row, colors } from '@dexma/ui-components';
import styled from 'styled-components';

export const HeaderRow = styled(Row)`
    padding-top: 16px;
    padding-bottom: 16px;
    padding-left: 24px;
    padding-right: 24px;
    background-color: ${colors.gray50};
`;

export const TitleCell = styled(Cell)`
    padding-left: 16px;
    display: flex;
    align-items: center;
`;

export const HeadingNoMargin = styled(Heading)`
    margin: 0;
`;

export const ActionButtons = styled.div`
    display: flex;
    flex-direction: row;
    button {
        margin-right: 8px;
    }
`;
